module.exports = __webpack_public_path__ + "img/beeldschermbril-taart.54d65959.svg";